module.exports = __webpack_public_path__ + "img/tower.9e694b4b.png";